if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.maxVariantQuantity = parseInt(this.dataset.maxVariantQuantity) || 0;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Flag to indicate that button state has been explicitly set by variant change logic
        this.buttonStateExplicitlySet = false;

        // Initialize simplified inventory logic
        this.initializeInventoryLogic();
      }

      // Initialize simplified inventory logic
      initializeInventoryLogic() {
        // Store original button text
        if (this.submitButtonText) {
          this.originalButtonText = this.submitButtonText.textContent;
        }

        // Subscribe to cart updates for inventory tracking
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          // Cart update event handling
        });

        // Also subscribe to quantity updates as a fallback
        this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, (event) => {
          // Quantity update event handling
        });

        // Listen for variant change events
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          this.handleVariantChange();
        });
      }

      // Check which promotion blocks this product qualifies for
      getQualifyingPromotions() {
        const qualifyingPromotions = [];
        const promotionBlocks = document.querySelectorAll('.metaobject-promotion-block');

        console.log('[ProductForm] Found promotion blocks:', promotionBlocks.length);

        promotionBlocks.forEach((block, index) => {
          try {
            // Look for the JSON script tag with promotion config
            const configScript = block.querySelector('script[data-promotion-config]');
            const config = configScript ? JSON.parse(configScript.textContent) : {};
            console.log(`[ProductForm] Block ${index} config:`, config);

            // Skip if promotion is disabled
            if (!config.enabled) {
              console.log(`[ProductForm] Block ${index} disabled`);
              return;
            }

            // Skip if action type is not 'add_product'
            if (config.actionType !== 'add_product') {
              console.log(`[ProductForm] Block ${index} not add_product action`);
              return;
            }

            // Check trigger conditions
            const qualifies = this.checkTriggerConditions(config);
            console.log(`[ProductForm] Block ${index} qualifies:`, qualifies);

            if (qualifies) {
              qualifyingPromotions.push({
                id: config.promotionName || 'promotion',
                config: config,
              });
            }
          } catch (error) {
            console.warn(`[ProductForm] Error parsing block ${index} config:`, error);
          }
        });

        console.log('[ProductForm] Final qualifying promotions:', qualifyingPromotions);
        return qualifyingPromotions;
      }

      // Check if current product meets trigger conditions
      checkTriggerConditions(config) {
        const triggerType = config.triggerType;
        const triggerValue = config.triggerValue;

        console.log('[ProductForm] Checking trigger conditions:', { triggerType, triggerValue });
        console.log('[ProductForm] Product data:', window.productData);

        switch (triggerType) {
          case 'product_tag':
            // Check if product has the specified tag
            const productTags = window.productData?.tags || [];
            console.log('[ProductForm] Product tags:', productTags);
            const hasTag = productTags.includes(triggerValue);
            console.log('[ProductForm] Has tag?', hasTag);
            return hasTag;

          case 'product_collection':
            // Check if product is in the specified collection
            const productCollections = window.productData?.collections || [];
            console.log('[ProductForm] Product collections:', productCollections);
            const inCollection = productCollections.some(
              (collection) => collection.handle === triggerValue || collection.id === triggerValue,
            );
            console.log('[ProductForm] In collection?', inCollection);
            return inCollection;

          default:
            console.log('[ProductForm] Unknown trigger type:', triggerType);
            return false;
        }
      }

      async updatePickupOnlyUI() {
        // With simplified logic, pickup-only UI is no longer needed
        // Products are only considered available if shipping warehouses have inventory
      }

      // Method to handle variant changes
      handleVariantChange() {
        // Variant change handling
      }

      getCart() {
        return fetch('/cart.js')
          .then((response) => response.json())
          .then((data) => data);
      }

      async getCurrentCartQuantity() {
        // Get the current product variant ID
        const productId = this.form.querySelector('[name="id"]').value;

        const cart = await this.getCart();

        // Try to get cart quantity from the cart notification/drawer
        if (cart && cart.items) {
          const cartItems = cart.items || [];
          const cartQuantity = cartItems.reduce((total, item) => {
            if (item.variant_id.toString() === productId.toString()) {
              return total + item.quantity;
            }
            return total;
          }, 0);

          return cartQuantity;
        }

        // Fallback: try to get from quantity input dataset
        const quantityInput = this.form.querySelector('[name="quantity"]');
        if (quantityInput && quantityInput.dataset.cartQuantity) {
          const cartQuantity = parseInt(quantityInput.dataset.cartQuantity) || 0;
          return cartQuantity;
        }

        return 0;
      }

      showPickupOnlyUI() {
        // With simplified logic, pickup-only UI is no longer needed
      }

      hidePickupOnlyUI() {
        // With simplified logic, pickup-only UI is no longer needed
      }

      showSoldOutUI() {
        // Check if there's a sold-out message element (existing pattern)
        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

        if (soldOutMessage) {
          this.submitButton.classList.add('sold-out');
          this.submitButtonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
        } else if (this.submitButtonText && this.originalButtonText) {
          this.submitButtonText.textContent = 'Sold Out';
          this.submitButton.classList.add('sold-out');
        }

        this.hidePickupOnlyCaption();
      }

      showPickupOnlyCaption() {
        // With simplified logic, pickup-only captions are no longer needed
      }

      hidePickupOnlyCaption() {
        // With simplified logic, pickup-only captions are no longer needed
      }

      // Simplified inventory tracking - no longer needed with simplified logic
      reEvaluatePickupOnlyStatus(cartResponse) {
        // Inventory re-evaluation skipped
      }

      // Public method to force cart state re-evaluation
      async forceCartStateReevaluation() {
        // Force cart state re-evaluation triggered
      }

      async checkCurrentCartState() {
        // Checking current cart state
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Prevent submission if button is in sold-out state
        if (this.submitButton.classList.contains('sold-out')) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Check if this product qualifies for any active promotion blocks
        const qualifyingPromotions = this.getQualifyingPromotions();
        console.log('[ProductForm] Qualifying promotions:', qualifyingPromotions);
        qualifyingPromotions.forEach((promotion) => {
          console.log(`[ProductForm] Adding property: _free-product-addon-${promotion.id}`);
          formData.append(`properties[_free-product-addon-${promotion.id}]`, 'true');
        });

        // Legacy support for old hasFreeProductAddon system
        if (this.dataset.hasFreeProductAddon === 'true') {
          formData.append('properties[_free-product-addon]', 'true');
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        await fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    const cartData = {
                      sections: response.sections || {},
                      id: formData.get('id'),
                    };

                    this.cart.renderContents(cartData);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              const cartData = {
                sections: response.sections || {},
                id: formData.get('id'),
              };

              this.cart.renderContents(cartData);
            }
          })
          .catch((e) => {
            console.error('Cart add error:', e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        // Mark that button state has been explicitly set by variant change logic
        this.buttonStateExplicitlySet = true;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }

        // Reset the flag after a short delay to allow pickup-only logic to work again
        setTimeout(() => {
          this.buttonStateExplicitlySet = false;
        }, 500);
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      disconnectedCallback() {
        // Clean up cart update subscription
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        // Clean up quantity update subscription
        if (this.quantityUpdateUnsubscriber) {
          this.quantityUpdateUnsubscriber();
        }

        // Clean up variant change subscription
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }
    },
  );
}
